exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-index-og-js": () => import("./../../../src/pages/index-og.js" /* webpackChunkName: "component---src-pages-index-og-js" */),
  "component---src-pages-license-js": () => import("./../../../src/pages/license.js" /* webpackChunkName: "component---src-pages-license-js" */),
  "component---src-pages-merkle-proof-js": () => import("./../../../src/pages/merkle-proof.js" /* webpackChunkName: "component---src-pages-merkle-proof-js" */)
}

